import { RootState } from "../../../../../store";
import { ForecastOption } from "../../../../../../services/cloudchipr.api";
import { costBreakdownV2SetupPropertyByKeySelector } from "../../../setups/cost-breakdown-v2/costBreakdownV2SetupPropertyByKeySelector";

export const costBreakdownV2WidgetSetupForecastedOptionSelector = (
  state: RootState,
): ForecastOption | undefined => {
  return costBreakdownV2SetupPropertyByKeySelector("forecastOption")(state);
};
